<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
                v-if="role!='Store'"
                :link="{
                  name: 'Ordenes',
                  path: '/ordenes',
                  icon: 'img/theme/icn_ordenes.svg'
                }">
        </sidebar-item>
        <sidebar-item
                v-if="role=='Super'"
                :link="{
                  name: 'Hospitales',
                  path: '/hospitales',
                  icon: 'img/theme/icn_hospitales.svg'
                }">
        </sidebar-item>
        <sidebar-item
                v-if="role=='Super'"
                :link="{
                  name: 'Áreas',
                  path: '/areas',
                  icon: 'img/theme/icn_hospitales.svg'
                }">
        </sidebar-item>
        <sidebar-item
                v-if="role=='Super'"
                :link="{
                  name: 'Modelos',
                  path: '/modelos',
                  icon: 'img/theme/icn_modelos.svg'
                }">
        </sidebar-item>
        <sidebar-item
                v-if="role!='Store'"
                :link="{
                  name: 'Usuarios',
                  path: '/usuarios',
                  icon: 'img/theme/icn_usuarios.svg'
                }">
        </sidebar-item>
        <sidebar-item
                v-if="role!='Admin'"
                :link="{
                  name: 'Estatus del pedido',
                  path: '/pedidos/estado',
                  icon: 'img/theme/icn_estatus.svg'
                }">
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    data() {
      return {
        role: ''
      };
    },
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      }
    },
    created() {
      this.role = localStorage.getItem('role')
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>
<style lang="scss">
</style>
